import { Button } from '@newcore/ui/buttons';
import { ButtonVariants } from '@newcore/ui/enums/variants';
import type { DocLink } from '../constants/mcp-tester-content';

interface DocLinksProps {
  links: DocLink[];
}

export function DocLinks({ links }: DocLinksProps) {
  return (
    <div className='flex flex-wrap gap-x-4 gap-y-1 pt-1'>
      {links.map(link => (
        <Button key={link.url} variant={ButtonVariants.LINK_PRIMARY} asChild>
          <a href={link.url} target='_blank' rel='noreferrer'>
            {link.label}
          </a>
        </Button>
      ))}
    </div>
  );
}
